import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientBase } from './http-client-base.service';

@Injectable({
  providedIn: 'root',
})
export class UsuariosRolesService extends HttpClientBase {
  constructor(http: HttpClient) {
    super(http, 'usuarios-roles'); // 👈 Base URL del backend
  }

  /** Obtener los roles de un usuario */
  getUserRoles(userId: string) {
    return this.get<any>({
      endpoint: `${userId}`,
      trackLoading: true,
    });
  }

  /** Asignar un rol a un usuario */
  assignRole(userId: string, roleId: number) {
    return this.post<any>(
      { roleId },                     // BODY
      `${userId}/asignar`,           // ENDPOINT
      undefined,                     // HEADERS
      true                           // trackLoading
    );
  }

  /** Remover un rol del usuario */
  removeRole(userId: string, roleId: number) {
    return this.delete<any>(
      `${userId}/remover/${roleId}`, // ENDPOINT
      undefined,                     // PARAMS
      undefined,                     // HEADERS
      true                           // trackLoading
    );
  }

  /** Reemplazar todos los roles de un usuario */
  setRoles(userId: string, roles: number[]) {
    return this.post<any>(
      { roles },                     // BODY
      `${userId}/set`,               // ENDPOINT
      undefined,                     // HEADERS
      true                           // trackLoading
    );
  }
}
